import * as actionTypes from 'store/common/actionTypes';

// eslint-disable-next-line import/prefer-default-export
export const resetApp = () => ({ type: actionTypes.RESET_APP });
